import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "aria-live": "assertive",
  class: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-500 top-20"
}
const _hoisted_2 = { class: "flex w-full flex-col items-center space-y-4 sm:items-end" }
const _hoisted_3 = { class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white ring-1 shadow-lg ring-black/5" }
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = { class: "shrink-0" }
const _hoisted_7 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_9 = { class: "ml-4 flex shrink-0" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_ExclamationTriangleIcon = _resolveComponent("ExclamationTriangleIcon")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert, index) => {
        return (_openBlock(), _createBlock(_Transition, {
          key: `${index}-alert-${alert.id}`,
          "enter-active-class": "transform ease-out duration-300 transition",
          "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
          "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (alert.type === _ctx.alertTypes.success)
                      ? (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                          key: 0,
                          class: "size-6 text-green-400",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true),
                    (alert.type === _ctx.alertTypes.error)
                      ? (_openBlock(), _createBlock(_component_XCircleIcon, {
                          key: 1,
                          class: "size-6 text-red-400",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true),
                    (alert.type === _ctx.alertTypes.warning)
                      ? (_openBlock(), _createBlock(_component_ExclamationTriangleIcon, {
                          key: 2,
                          class: "size-5 text-yellow-400",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true),
                    (alert.type === _ctx.alertTypes.info)
                      ? (_openBlock(), _createBlock(_component_InformationCircleIcon, {
                          key: 3,
                          class: "size-6 text-blue-400",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(alert.message), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: ($event: any) => (_ctx.hideAlert(alert)),
                      class: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                    }, [
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Close", -1)),
                      _createVNode(_component_XMarkIcon, {
                        class: "size-5",
                        "aria-hidden": "true"
                      })
                    ], 8, _hoisted_10)
                  ])
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
}